import React, { Component } from 'react';
import { ButtonToolbar, Button, Table, Row, Col, Grid } from 'react-bootstrap';

import { PropTypes } from 'prop-types';
import { FareProductsForm } from './FareProductsForm';
import { DefaultRules } from './rules/DefaultRules';
import { FlatFareRules } from './rules/FlatFareRules';
import { DistanceFareRules } from './rules/DistanceFareRules';
import { HoneyCombFareRules } from './rules/HoneyCombFareRules';
import { ZoneFareRules } from './rules/ZoneFareRules';
import { FareProductsCommand } from '../commands/FareProductsCommand';
import { CurrenciesCommand } from '../commands/CurrenciesCommand';
import { FaresCommand } from '../commands/FaresCommand';
import { RegionsCommand } from '../commands/RegionsCommand';
import { TitleRow } from '../../TitleRow';
import { SearchBar } from '../../SearchBar';
import { LoadingSpinner } from '../../LoadingSpinner';
import { TableButton } from '../../TableButton';
import { PaginationBuilder } from '../../PaginationBuilder';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';

import ColumnResize from "react-table-column-resizer";

export class FareProducts extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string
    }

    constructor(props) {
        super(props);

        this.state = {
            commands: {
                fareProducts: new FareProductsCommand(),
                currencies: new CurrenciesCommand(),
                fares: new FaresCommand(),
                regions: new RegionsCommand()
            },
            table: {
                data: [],
                page: 1,
                elementsPerPage: 50,
                filter: ""
            },
            dependencies: {
                currencies: [],
                fares: [],
                regions: [],
            },
            form: {
                title: undefined,
                model: undefined,
                original: undefined
            },
            rules: {
                original: undefined,
                model: undefined,
                type: undefined
            },
            render: {
                rulesComponents: {
                    "Default": DefaultRules,
                    "FlatFareRules": FlatFareRules,
                    "DistanceFareRules": DistanceFareRules,
                    "HoneyCombFareRules": HoneyCombFareRules,
                    "ZoneFareRules": ZoneFareRules
                }
            },
            actions: {
                isLoading: true,
                isLoadingCurrencies: true,
                isLoadingFares: true,
                isLoadingRegions: true,
                isUpdating: false,
                isDeleting: false
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);

        this.getFareProducts();
        this.getCurrencies();
        this.getFares();
        this.getRegions();
    }

    // ---------------------------

    getFareProducts(resetData = false) {
        if (resetData) {
            const { table } = this.state;

            table.data = [];
            
            this.setState({
                table: table
            });
        }
        
        const { selectedProvider } = this.context;
        
        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }
        
        const { commands, actions } = this.state;

        actions.isLoading = true;
        commands.fareProducts.getAll(
            selectedProviderId,
            (a) => this.listSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    getCurrencies() {
        const { selectedProvider } = this.context;

        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions.isLoadingCurrencies = true;
        this.setState({
            actions: actions
        });

        commands.currencies.getAll(
            selectedProviderId,
            (a) => this.listDependenciesSuccessCallback(a, "currencies", "isLoadingCurrencies"),
            (a) => this.listDependenciesErrorCallback(a, "currencies", "isLoadingCurrencies")
        );
    }

    getFares() {
        const { commands, actions } = this.state;

        actions.isLoadingFares = true;
        this.setState({
            actions: actions
        });

        commands.fares.getAll(
            (a) => this.listDependenciesSuccessCallback(a, "fares", "isLoadingFares"),
            (a) => this.listDependenciesErrorCallback(a, "fares", "isLoadingFares")
        );
    }

    getRegions() {
        const { selectedProvider } = this.context;

        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions.isLoadingRegions = true;
        this.setState({
            actions: actions
        });

        commands.regions.getAll(
            selectedProviderId,
            (a) => this.listDependenciesSuccessCallback(a, "regions", "isLoadingRegions"),
            (a) => this.listDependenciesErrorCallback(a, "regions", "isLoadingRegions")
        );
    }

    // ---------------------------

    listSuccessCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    listErrorCallback(messageReceived) {
        const { table, actions, message } = this.state;

        actions.isLoading = false;
        table.data = [];
        table.page = 1;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    listDependenciesSuccessCallback(result, data, action) {
        const { dependencies, actions } = this.state;

        actions[action] = false;
        dependencies[data] = result;

        this.setState({
            dependencies: dependencies,
            actions: actions
        });
    }

    listDependenciesErrorCallback(messageReceived, data, action) {
        const { dependencies, actions, message } = this.state;

        actions[action] = false;
        dependencies[data] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getFareProducts();
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onCreateClick() {
        const { form } = this.state;

        form.original = null;
        form.model = {
            id: 0,
            name: "",
            state: 0,
            currencyId: 0,
        };
        form.title = "Criar";

        this.setState({
            form: form
        });
    }

    onRulesClick(data) {
        const { rules } = this.state;

        rules.original = data;
        rules.model = Object.assign({}, data);
        rules.type = data.fare.rulesType || "Default";

        if (Array.isArray(rules.model.rules)) {
            rules.model.rules = rules.model.rules.map(rule => Object.assign({}, rule));
        }

        this.setState({
            rules: rules
        });
    }

    onEditClick(data) {
        const { form } = this.state;

        form.original = data;
        form.model = Object.assign({}, data);
        form.title = "Editar";

        this.setState({
            form: form
        });
    }

    onDeleteClick(model) {
        const { selectedProvider } = this.context;

        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar o Produto "${model.name}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    provider: selectedProviderId,
                    id: model.id
                }
            }
        });
    }

    onSave(data, exitCallback) {
        const { selectedProvider } = this.context;

        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;
        commands.fareProducts.save(
            selectedProviderId,
            data,
            (a) => this.operationSuccessCallback(a, "isUpdating"),
            (a) => this.operationErrorCallback(a, "isUpdating")
        );

        actions.isUpdating = true;
        this.setState({
            actions: actions
        });

        if ("function" === typeof (exitCallback)) {
            exitCallback();
        }
        else {
            this.onFormExit();
        }
    }

    onFormExit() {
        this.setState({
            form: {
                title: undefined,
                model: undefined,
                original: undefined,
            }
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { commands } = this.state;
            commands.fareProducts.delete(
                argument.provider,
                argument.id,
                (a) => this.operationSuccessCallback(a, "isDeleting"),
                (a) => this.operationErrorCallback(a, "isDeleting")
            );

            actions.isDeleting = true;
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    onExitRules() {
        this.setState({
            rules: {
                original: undefined,
                model: undefined,
                type: undefined,
            }
        });
    }

    // -----------------

    onChangePage(page) {
        const { table } = this.state;

        table.page = page;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elements) {
        const { table } = this.state;

        table.elementsPerPage = elements;

        this.setState({
            table: table
        });
    }

    onSearch(filter) {
        const { table } = this.state;

        table.filter = filter;

        this.setState({
            table: table
        });
    }

    // ---------------

    renderForm(isLoadingDependencies) {
        const { form } = this.state;

        if (null === form.model || undefined === form.model) {
            return null;
        }

        const { dependencies } = this.state;

        return (
            <FareProductsForm title={form.title}
                model={form.model}
                currencies={dependencies.currencies}
                fares={dependencies.fares}
                regions={dependencies.regions}
                isLoadingDependencies={isLoadingDependencies}
                onSave={(a) => this.onSave(a)}
                onHide={() => this.onFormExit()} />
        );
    }

    renderRules() {
        const { rules, render } = this.state;

        if (null === rules.model || undefined === rules.model) {
            return null;
        }

        const reactElement = render.rulesComponents[rules.type];

        return React.createElement(
            reactElement || DefaultRules,
            {
                model: rules.model,
                isEditable: rules.model.isEditable,
                onSave: (a) => this.onSave(a, () => this.onExitRules()),
                onExit: () => this.onExitRules()
            }
        );
    }

    renderState(state) {
        let label = "";

        switch (state) {
            case 0:
            case "0":
                label = "Ativo";
                break;

            case 1:
            case "1":
                label = "Inativo";
                break;

            default: break;
        }

        return label;
    }

    renderFareName(fare) {
        if (undefined === fare) {
            return "";
        }

        return fare.name;
    }

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderTable(isWaiting) {
        const { table } = this.state;

        const dataFiltered = SearchHelper.search({
            filter: table.filter,
            data: table.data,
            fields: ["name", "state", "currencyName"],
            valueParser: {
                "state": {
                    "0": "ativa",
                    "1": "inativa"
                }
            }
        });
        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, table.elementsPerPage);
        const activePage = totalPages < table.page ? totalPages : table.page;
        const partialData = dataFiltered.slice((activePage - 1) * table.elementsPerPage, activePage * table.elementsPerPage);

        return (
            <Grid fluid>
                <Row>
                    <Col sm={12}>
                        <div className="table-loading">
                            <Table responsive striped hover>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>Estado</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>Tipo de Tarifário</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>Moeda</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody className={isWaiting ? "overlay" : ""}>
                                    {
                                        partialData.map((data, i) =>
                                            <tr key={`set-${i}`}>
                                                <td>{data.name}</td>
                                                <td className="column_resizer_body" />
                                                <td>{this.renderState(data.state)}</td>
                                                <td className="column_resizer_body" />
                                                <td>{this.renderFareName(data.fare)}</td>
                                                <td className="column_resizer_body" />
                                                <td>{data.currencyName}</td>
                                                <td className="column_resizer_body" />
                                                <td>
                                                    <ButtonToolbar className="pull-right">
                                                        <TableButton marginRight icon="icon-definitions" title="Regras" onClick={() => this.onRulesClick(data)} />
                                                        <TableButton marginRight icon="icon-edit" title="Editar" disabled={!data.isEditable} onClick={() => this.onEditClick(data)} />
                                                        <TableButton icon="icon-trash" title="Eliminar" disabled={!data.isEditable} onClick={() => this.onDeleteClick(data)} />
                                                    </ButtonToolbar>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>

                            <PaginationBuilder
                                currentPage={activePage}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={dataFiltered.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />

                            {this.renderLoading(isWaiting)}
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }

    render() {
        const { actions, message, dialog } = this.state;

        return (
            <div>
                <TitleRow title="Produtos" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        <ButtonToolbar className="pull-right title-row-col-btns">
                            <Button onClick={() => this.onCreateClick()}>CRIAR</Button>
                        </ButtonToolbar>
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                {this.renderTable(actions.isLoading || actions.isUpdating || actions.isDeleting)}
                {this.renderForm(actions.isLoadingCurrencies || actions.isLoadingFares || actions.isLoadingRegions)}
                {this.renderRules()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
